define('shared/initializer/form/adapters/mixins/GenericFieldStackable',[
    '$',
    'shared/lib/RSVP'
], 
function (
    $,
    RSVP
) {
    'use strict';

    var $html = $('html');
    var SELECTOR = '[data-next]';

    function showNext($el, attrNext) {
        var prms = [];
        var $result = eval('$el' + attrNext);
        $result.show();
        $result.each(function(i, el){
            prms.push(new RSVP.Promise(function(resolve){
                var $el = $(el);
                var targetHeight = $el.height();
                $el
                    .css({
                        height: 0
                    })
                    .animate({
                        height: targetHeight
                    })
                    .promise()
                    .then(function(){
                        $el
                            .css({
                                height: 'auto'
                            });
                        resolve();
                    });
            }));
        });
        return RSVP.all(prms);
    }

    function handleEntryStart(item) {
        return new RSVP.Promise(function(resolve){
            var $wrap = item.$wrap;

            function handleClick(evt){
                var $el = $(evt.currentTarget);
                var attrNext = $el.attr('data-next');
                if (evt.handled) {
                    return;
                }
                if (attrNext === 'DONE') {
                    item.value = $el.attr('data-code');
                    $wrap
                    .animate({
                        height: 0
                    }, 500)
                    .promise()
                    .then(function(){
                        $wrap.hide();
                        $wrap.off('click', SELECTOR, handleClick);
                        resolve();
                    });
                }
                else {
                    showNext($el, attrNext);
                }
                evt.handled = true;
            }

            $wrap.on('click', SELECTOR, handleClick);

            $wrap.show();
            var targetHeight = $wrap.height();
            $wrap
                .css({
                    height: 0
                })
                .animate({
                    height: targetHeight
                })
                .promise()
                .then(function(){
                    $wrap
                        .css({
                            height: 'auto'
                        });

                    var prm;
                    var $start = $wrap.find('[data-start]');
                    var $finish = $wrap.find('[data-finish]');
                    if ($start.length > 0){
                        var attrNext = $start.attr('data-next');
                        prm = showNext($start, attrNext);
                    }
                    else if($finish.length > 0) {
                        resolve();
                        prm = RSVP.resolve();
                    }
                    else {
                        prm = RSVP.resolve();
                    }
                    return prm;
                });
        });
    }

    function handleEntryStartWrapper(item){
        return function(){
            return handleEntryStart(item);
        };
    }

    function Ctor() {
        this.$form.parent().addClass('generic-field-stackable');
    }

    var p = Ctor.prototype;
    p.doPageLoad = function() {
        var me = this;
        var arr = [];
        var prm = RSVP.resolve();

        for(var key in me.generics){
            if (me.generics.hasOwnProperty(key) === false){
                continue;
            }

            arr[me.generics[key].index] = me.generics[key];
        }

        for(var i = 0; i < arr.length; i++) {
            if ($html.hasClass('edit') === false) {
                arr[i].$wrap.hide();
            }
            prm = prm.then(handleEntryStartWrapper(arr[i]));
        }

        prm.then(function(){
            me.$form.submit();
        });

        return RSVP.resolve();
    };

    p.doSubmitFail = p.doPageLoad;

    return Ctor;
});
